import { Typography } from "@mui/material";
import { OLPaper } from "OLPaper";
import { useStyles } from "./styles";

export const ImportTableWrapper = ({
  children,
  tableName,
}: {
  children: React.ReactNode;
  tableName: string;
}) => {
  const classes = useStyles();

  return (
    <OLPaper className={classes.tableWrapper}>
      <Typography className={classes.tableWrapperTitle}>{tableName}</Typography>
      {children}
    </OLPaper>
  );
};
